/** 对齐吸附：画布边缘/中心 + 其他图层边缘/中心，阈值 4 设计像素。 */
import { CANVAS_WIDTH, type Layer, type Rect } from '@h5/schema';

export const SNAP_THRESHOLD = 4;

export interface SnapResult {
  dx: number;
  dy: number;
  vLines: number[]; // x 坐标
  hLines: number[]; // y 坐标
}

function xs(r: Rect) { return [r.x, r.x + r.w / 2, r.x + r.w]; }
function ys(r: Rect) { return [r.y, r.y + r.h / 2, r.y + r.h]; }

export function computeSnap(
  moving: Rect,
  others: Layer[],
  canvasHeight: number,
  threshold = SNAP_THRESHOLD,
): SnapResult {
  const candX = [0, CANVAS_WIDTH / 2, CANVAS_WIDTH];
  const candY = [0, canvasHeight / 2, canvasHeight];
  for (const l of others) {
    if (l.hidden) continue;
    candX.push(...xs(l.rect));
    candY.push(...ys(l.rect));
  }
  let bestDx = 0, bestX = Infinity; const vLines: number[] = [];
  for (const mx of xs(moving)) for (const cx of candX) {
    const d = cx - mx;
    if (Math.abs(d) <= threshold && Math.abs(d) < Math.abs(bestX)) { bestX = d; bestDx = d; }
  }
  let bestDy = 0, bestY = Infinity; const hLines: number[] = [];
  for (const my of ys(moving)) for (const cy of candY) {
    const d = cy - my;
    if (Math.abs(d) <= threshold && Math.abs(d) < Math.abs(bestY)) { bestY = d; bestDy = d; }
  }
  if (bestX !== Infinity) {
    const snapped = { ...moving, x: moving.x + bestDx };
    for (const mx of xs(snapped)) if (candX.some((c) => Math.abs(c - mx) < 0.01)) vLines.push(mx);
  }
  if (bestY !== Infinity) {
    const snapped = { ...moving, y: moving.y + bestDy };
    for (const my of ys(snapped)) if (candY.some((c) => Math.abs(c - my) < 0.01)) hLines.push(my);
  }
  return { dx: bestX === Infinity ? 0 : bestDx, dy: bestY === Infinity ? 0 : bestDy, vLines, hLines };
}
